var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon49BlogBeer2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.96 7.02c4.17-.4 5.12 1.55 9.18 1.23",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.1 2-.09 19.39c0 .33-.2.62-.53.62H8.63c-.33 0-.54-.31-.54-.62L8 2h7.1m.01-2H8a2 2 0 0 0-2 2l.1 19.4A2.58 2.58 0 0 0 8.62 24h5.85A2.55 2.55 0 0 0 17 21.4l.1-19.28V2a2 2 0 0 0-2-2z",
    fill: "#000"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+DQogIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+DQogICAgPHBhdGggZD0iTTYuOTYgNy4wMmM0LjE3LS40IDUuMTIgMS41NSA5LjE4IDEuMjMiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIyIi8+DQogICAgPHBhdGggZD0ibTE1LjEgMi0uMDkgMTkuMzljMCAuMzMtLjIuNjItLjUzLjYySDguNjNjLS4zMyAwLS41NC0uMzEtLjU0LS42Mkw4IDJoNy4xbS4wMS0ySDhhMiAyIDAgMCAwLTIgMmwuMSAxOS40QTIuNTggMi41OCAwIDAgMCA4LjYyIDI0aDUuODVBMi41NSAyLjU1IDAgMCAwIDE3IDIxLjRsLjEtMTkuMjhWMmEyIDIgMCAwIDAtMi0yeiIgZmlsbD0iIzAwMCIgLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
export { SvgIcon49BlogBeer2 as ReactComponent };